// One place for how a 0-100 score looks and reads across Results, Dashboard
// and the accent test.

export const tone = (score) => {
  if (score >= 80) return { text: 'text-emerald-300', bar: 'from-emerald-400 to-teal-300', soft: 'bg-emerald-400/10 border-emerald-400/20 text-emerald-200', hex: '#34D399' };
  if (score >= 60) return { text: 'text-amber-300', bar: 'from-amber-400 to-yellow-300', soft: 'bg-amber-400/10 border-amber-400/20 text-amber-200', hex: '#FBBF24' };
  return { text: 'text-rose-300', bar: 'from-rose-400 to-orange-300', soft: 'bg-rose-400/10 border-rose-400/20 text-rose-200', hex: '#FB7185' };
};

export const level = (score) => {
  if (score >= 90) return 'Excellent';
  if (score >= 80) return 'Very good';
  if (score >= 70) return 'Good';
  if (score >= 60) return 'Fair';
  if (score >= 50) return 'Needs practice';
  return 'Needs work';
};
